<template>
  <el-input v-model="phoneModel" :size="size"s style="max-width:400px">
    <template slot="append">
      <span class="pr-15" style="position:relative;top:-5px;">Ext.:</span>
      <el-input v-model="extModel" :size="size" placeholder="Extension" :class="size"></el-input>
    </template>
  </el-input>
</template>
<script>
export default {
	name: 'Phone',
  props: {
    data : {type : Object},
    size : {type : String, default : 'big'}
	},
  data() {
    return {
      model : {
        phone : null,
        ext : null,
      }
    };
  },
  methods : {

  },
	computed : {
    phoneModel : {
      set(phone){
        this.$emit('updatePhone', phone);
      },
      get(){return this.data.phone}
    },
    extModel : {
      set(ext){
        this.$emit('updateExt', ext);
      },
      get(){return this.data.ext}
    }
	},
  mounted(){
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.small{
  height:25px;position:relative;top:-3px;min-width:60px;
}

.medium{
    height:25px;position:relative;top:-4px;min-width:80px;
}

.big{
    height:25px;position:relative;top:-5px;min-width:80px;
}

</style>
